export function getCommunityDashboardPath(communityId: string) {
  return `/${communityId}/dashboard`;
}

export function getInvitePath(inviteCode: string) {
  return `/invite/${encodeURIComponent(inviteCode)}`;
}

export function getLoginPathForInvite(inviteCode: string) {
  return `/login?inviteCode=${encodeURIComponent(inviteCode)}`;
}

export function persistInviteCode(inviteCode: string) {
  sessionStorage.setItem('invite_code', inviteCode);
}

export function getPersistedInviteCode(): string | null {
  return sessionStorage.getItem('invite_code');
}

export function clearPersistedInviteCode() {
  sessionStorage.removeItem('invite_code');
}

export function getActiveInviteCode(explicitCode?: string | null) {
  return explicitCode || getPersistedInviteCode();
}

export function resolvePostAuthDestination(params: {
  joinedCommunityId?: string | null;
  fallback?: string;
}) {
  const { joinedCommunityId, fallback = '/dashboard' } = params;

  if (joinedCommunityId) {
    clearPersistedInviteCode();
    return getCommunityDashboardPath(joinedCommunityId);
  }

  clearPersistedInviteCode();
  return fallback;
}

export function resolveSafeRedirectPath(redirect?: string | null) {
  if (!redirect) return null;

  const value = redirect.trim();
  if (!value || value.startsWith('//')) return null;

  try {
    const url =
      value.startsWith('/') || typeof window === 'undefined'
        ? new URL(value, 'https://milora.local')
        : new URL(value, window.location.origin);

    if (
      typeof window !== 'undefined' &&
      !value.startsWith('/') &&
      url.origin !== window.location.origin
    ) {
      return null;
    }

    const path = `${url.pathname}${url.search}${url.hash}`;
    if (
      path === '/login' ||
      path.startsWith('/login?') ||
      path === '/register' ||
      path.startsWith('/register?')
    ) {
      return null;
    }

    return path;
  } catch {
    return null;
  }
}
